import { MARQUEE_ITEMS } from "@/data/site";

export const Marquee = ({ dark = false }) => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className={`marquee relative overflow-hidden py-6 ${dark ? "bg-grad-dark" : "bg-white border-y border-pink-100"}`} data-testid="marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className={`flex items-center gap-10 text-sm sm:text-base font-medium tracking-[0.2em] uppercase ${dark ? "text-pink-100" : "text-zinc-700"}`}>
            {t}
            <span className="w-2 h-2 rounded-full bg-grad-pink inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
